import React from 'react'

const Needs = () => {
  return (
    <div className='cta'>
        <a href='https://docs.google.com/document/d/16RXZ9JadDSYErfe8SN0oPHPNnL0OIA_oh6rH_Q8rf5A/edit' className='btn'>Resume</a>
        <a href="#contact" className='btn btn-primary'>Let's Talk</a>
    </div>
  )
}

export default Needs